import { Row } from 'antd'
import React from 'react'
import { capitalize } from 'lodash'
import { Link } from 'react-router-dom'

function FormSectionTitle (props) {
  const { title, padding, color, marginBottom = '10px', link } = props
  const text = title
    .split(' ')
    .map(capitalize)
    .join(' ')
  return (
    <div>
      <Row style={{ paddingBottom: padding, paddingTop: padding }}>
        <h2
          style={{
            marginBottom,
            color: color,
            fontWeight: 'bold',
            fontSize: '16px',
            lineHeight: '1.5',
          }}>
          {link ? <Link to={link}>{text}</Link> : text}
        </h2>
        <Row style={{ paddingBottom: padding, paddingTop: padding }}/>
      </Row>
    </div>
  )
}

FormSectionTitle.defaultProps = {
  padding: '10px',
  title: 'NO TITLE',
  color: 'rgba(0, 0, 0, 0.85)',
}
export default FormSectionTitle
